<template>
  <v-list-tile v-if="!isEditing" avatar ripple class="it-hv">
    <v-list-tile-avatar>
      <font-awesome-icon v-if="isStatusDone" :icon="['fas', 'id-card']"></font-awesome-icon>
      <font-awesome-icon v-else :icon="['fal', 'id-card']"></font-awesome-icon>
    </v-list-tile-avatar>
    <v-list-tile-content>
      <v-list-tile-sub-title class="caption" v-if="isStatusYes || isStatusDone"><span class="font-weight-bold" v-if="!isTypeEmpty">種類：</span>{{ printType }}</v-list-tile-sub-title>
      <v-list-tile-title>{{ (isStatusYes || isStatusDone) ? printCountry : printStatus }}</v-list-tile-title>
      <v-list-tile-sub-title class="caption" v-if="isStatusYes">
        <span class="font-weight-bold" v-if="!isTermEmpty">有効期間：</span>{{ printTerm }}
      </v-list-tile-sub-title>
      <v-list-tile-sub-title class="caption" v-if="isStatusDone">
        <span class="font-weight-bold">発行日：</span>{{ printPublishDate }}
      </v-list-tile-sub-title>
      <v-list-tile-sub-title class="caption" v-if="isStatusNo">
        <span class="font-weight-bold">手配：</span>{{ printArranger }}
      </v-list-tile-sub-title>
    </v-list-tile-content>
    <v-list-tile-action>
      <v-tooltip bottom v-if="!isStatusDone">
        <v-btn flat icon slot="activator" class="blue--text text--darken-2" :loading="isThisLoading || isLoading" @click="edit"><font-awesome-icon :icon="['fal', 'pencil']"/></v-btn>
        <span>編集する</span>
      </v-tooltip>
      <v-menu offset-y v-else>
        <v-btn flat icon slot="activator" class="blue--text text--darken-2" :loading="isThisLoading"><v-icon>more_vert</v-icon></v-btn>
        <v-list>
          <v-list-tile @click="edit">
            <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'pencil']"/></v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>編集する</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile @click="remove">
            <v-list-tile-avatar><font-awesome-icon :icon="['fal', 'trash-alt']"/></v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title>削除する</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-menu>
    </v-list-tile-action>
    <UtilConfirmModal ref="confirm"></UtilConfirmModal>
  </v-list-tile>
  <v-container v-else>
    <v-layout wrap class="pb-4">
      <v-flex xs12 class="px-3" v-if="!isStatusDone">
        <v-radio-group required row
          v-model="form.status"
          :rules="rules.status"
          @change="changed">
          <v-radio v-for="(item, key) in getStatusItems" :key="key"
            color="blue darken-2"
            :label="item"
            :value="key"></v-radio>
        </v-radio-group>
      </v-flex>
      <v-flex xs12 class="px-3" v-if="isFormStatusYes || isFormStatusDone">
        <v-select
          v-model="form.country"
          label="発行国"
          item-text="label"
          item-value="code"
          :rules="rules.country"
          :items="getNationItems"></v-select>
      </v-flex>
      <v-flex xs12 class="px-3" v-if="isFormStatusYes || isFormStatusDone">
        <v-select
          v-model="form.type"
          label="ビザの種類"
          item-text="text"
          item-value="value"
          :rules="rules.country"
          :items="getTypeItems"></v-select>
      </v-flex>
      <v-flex xs12 class="px-3" v-if="isFormStatusYes || isFormStatusDone">
        <v-menu lazy offset-y full-width
          v-model="config.datepicker.publish"
          transition="scale-transition"
          min-width="290px"
          :close-on-content-click="false">
          <v-text-field readonly required
            v-model="printFormatedPublish"
            :rules="rules.publish"
            slot="activator"
            label="発行日"></v-text-field>
          <v-date-picker
            v-model="form.publish"
            color="amber"
            locale="ja"
            :day-format="date => new Date(date).getUTCDate()"
            @input="config.datepicker.publish = false"></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 class="px-3" v-if="isFormStatusYes">
        <v-menu lazy offset-y full-width
          v-model="config.datepicker.expire"
          transition="scale-transition"
          min-width="290px"
          :close-on-content-click="false">
          <v-text-field readonly required
            v-model="printFormatedExpire"
            :rules="rules.expire"
            slot="activator"
            label="失効日"></v-text-field>
          <v-date-picker
            v-model="form.expire"
            color="amber"
            locale="ja"
            :day-format="date => new Date(date).getUTCDate()"
            @input="config.datepicker.expire = false"></v-date-picker>
        </v-menu>
      </v-flex>
      <v-flex xs12 class="px-3" v-if="isFormStatusNo">
        <v-radio-group required row
          v-model="form.arranger"
          :rules="rules.arranger">
          <v-radio v-for="(item, key) in getArrangerItems" :key="key"
            color="blue darken-2"
            :label="item"
            :value="key"></v-radio>
        </v-radio-group>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
  </v-container>
</template>

<script>
import UtilConfirmModal from '@/components/modals/confirm'
export default {
  name: 'clientAboutBackgroundsVisa',
  components: {
    UtilConfirmModal
  },
  props: [
    'status',
    'data'
  ],
  data () {
    return {
      config: {
        type: 'visa',
        status: {
          loading: false
        },
        datepicker: {
          publish: false,
          expire: false
        }
      },
      form: {
        id: '',
        status: '',
        country: '',
        type: '',
        publish: '',
        expire: '',
        arranger: ''
      },
      rules: {
        status: [
          v => !!v || '必須項目です'
        ],
        country: [
          v => !!v || '必須項目です'
        ],
        type: [
          v => !!v || '必須項目です'
        ],
        publish: [
          v => !!v || '必須項目です'
        ],
        expire: [
          v => !!v || '必須項目です'
        ],
        arranger: [
          v => !!v || '必須項目です'
        ]
      }
    }
  },
  methods: {
    prepare: function (dt) {
      if (dt) {
        this.$set(this, 'form', {
          id: '' + (dt.id ? dt.id : ''),
          status: dt.status ? dt.status : '',
          country: dt.country ? dt.country : '',
          type: dt.type ? dt.type : '',
          publish: dt.publish ? dt.publish : '',
          expire: dt.expire ? dt.expire : '',
          arranger: dt.arranger ? dt.arranger : ''
        })
      } else if (this.$props.data) {
        this.$set(this, 'form', {
          id: '' + (this.$props.data.id ? this.$props.data.id : ''),
          status: this.$props.data.status ? this.$props.data.status : '',
          country: this.$props.data.country ? this.$props.data.country : '',
          type: this.$props.data.type ? this.$props.data.type : '',
          publish: this.$props.data.publish ? this.$props.data.publish : '',
          expire: this.$props.data.expire ? this.$props.data.expire : '',
          arranger: this.$props.data.arranger ? this.$props.data.arranger : ''
        })
      }
    },
    edit: function () {
      this.prepare()
      this.$emit('emit', {
        action: 'edit',
        data: {
          id: (this.$props.data && this.$props.data.id) ? ('visa_' + this.$props.data.id) : '',
          type: this.config.type
        }
      })
    },
    changed: function () {
      this.prepare({
        id: '' + (this.$props.data.id ? this.$props.data.id : ''),
        status: this.form.status ? this.form.status : ''
      })
    },
    remove: function () {
      this.$refs.confirm.open({
        title: 'ビザ取得歴の削除',
        message: 'このビザ取得歴を削除してもよろしいですか？',
        callback: () => {
          this.$set(this.config.status, 'loading', true)
          this.axios.post(this.$url.api + 'user/about/delete/meta', {
            id: this.$props.data.id
          }, {
            headers: {
              'user-token': this.$localStorage.get('jwt')
            }
          }).then(res => {
            console.log(res)
            if (res.data && res.data.success) {
              this.$emit('emit', {
                action: 'remove',
                data: {
                  type: 'visas',
                  id: res.data.data.id ? res.data.data.id : ''
                }
              })
            }
          })
        }
      })
    },
    getForm: function () {
      return this.form
    }
  },
  computed: {
    isLoading () {
      return this.config.status.loading
    },
    isEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        (this.$props.status.editing === 'all' || this.$props.status.editing === ('visa_' + this.$props.data.id))
      )
    },
    isThisEditing () {
      return !!(
        this.$props.status &&
        this.$props.status.editing &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.editing === ('visa_' + this.$props.data.id)
      )
    },
    isThisLoading () {
      return !!(
        this.$props.status &&
        this.$props.status.loading &&
        this.$props.data &&
        this.$props.data.id &&
        this.$props.status.loading === ('visa_' + this.$props.data.id)
      )
    },
    printStatus () {
      return (
        this.$props.data &&
        this.$props.data.status &&
        this.$meta.visa.status[this.$props.data.status]
      ) ? this.$meta.visa.status[this.$props.data.status] : 'ビザの回答'
    },
    isStatusYes () {
      return !!(
        this.$props.data &&
        this.$props.data.status &&
        this.$props.data.status === 'YES'
      )
    },
    isStatusNo () {
      return !!(
        this.$props.data &&
        this.$props.data.status &&
        this.$props.data.status === 'NO'
      )
    },
    isStatusDone () {
      return !!(
        this.$props.data &&
        this.$props.data.status &&
        this.$props.data.status === 'DONE'
      )
    },
    isFormStatusYes () {
      return !!(
        this.form.status === 'YES'
      )
    },
    isFormStatusNo () {
      return !!(
        this.form.status === 'NO'
      )
    },
    isFormStatusDone () {
      return !!(
        this.form.status === 'DONE'
      )
    },
    printCountry () {
      return (
        this.$props.data &&
        this.$props.data.country &&
        this.$meta.nations[this.$props.data.country]
      ) ? this.$meta.nations[this.$props.data.country] : ''
    },
    printType () {
      return (
        this.$props.data &&
        this.$props.data.type &&
        this.$meta.visa.types[this.$props.data.type]
      ) ? this.$meta.visa.types[this.$props.data.type] : ''
    },
    printTerm () {
      return (
        this.$props.data
      ) ? [
          this.$props.data.publish ? this.$moment(this.$props.data.publish).format('YYYY/MM/DD') : '',
          this.$props.data.expire ? this.$moment(this.$props.data.expire).format('YYYY/MM/DD') : ''
        ].join('〜') : ''
    },
    printPublishDate () {
      return (
        this.$props.data && this.$props.data.publish
      ) ? this.$moment(this.$props.data.publish).format('YYYY/MM/DD') : ''
    },
    printFormatedPublish () {
      return (
        this.form &&
        this.form.publish
      ) ? this.$moment(this.form.publish).format('YYYY/MM/DD') : ''
    },
    printFormatedExpire () {
      return (
        this.form &&
        this.form.expire
      ) ? this.$moment(this.form.expire).format('YYYY/MM/DD') : ''
    },
    printArranger () {
      return (
        this.$props.data &&
        this.$props.data.arranger &&
        this.$meta.visa.arrangers[this.$props.data.arranger]
      ) ? this.$meta.visa.arrangers[this.$props.data.arranger] : ''
    },
    isStatusEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.status
      )
    },
    isTypeEmpty () {
      return !(
        this.$props.data &&
        this.$props.data.type
      )
    },
    isTermEmpty () {
      return !(
        this.$props.data &&
        [
          this.$props.data.publish ? this.$props.data.publish : '',
          this.$props.data.expire ? this.$props.data.expire : ''
        ].join('')
      )
    },
    getStatusItems () {
      return this.$meta.visa.status
    },
    getNationItems () {
      return Object.keys(this.$meta.nations).map(key => {
        return {
          code: key,
          label: this.$meta.nations[key]
        }
      })
    },
    getTypeItems () {
      return Object.keys(this.$meta.visa.types).map(key => {
        return {
          value: key,
          text: this.$meta.visa.types[key]
        }
      })
    },
    getArrangerItems () {
      return this.$meta.visa.arrangers
    }
  }
}
</script>
